const collapsibles = document.querySelectorAll("[data-collapsible]")
const collButtons = document.querySelectorAll("[data-collapsible-btn]")

window.addEventListener("resize", () => {
    if(screenWidth > 825) {
        let tempItems = document.querySelectorAll(".active")
        tempItems.forEach(item => {
            item.classList.remove("active")
        })
    }
})

collButtons.forEach((button, idx) => {
    button.addEventListener("click", () => {
        button.classList.toggle("active")
        collapsibles[idx].classList.toggle("active")

        if(button.classList.contains("active") && button.classList.contains("insurance-order-form"))
            resetIframeHeight()
    })
})
